export const dark = {
    title: 'dark',
    colors: {
        primary: '#1B1F38',
        secondary: '#252A48',
        tertiary: '#313862',

        white: '#FFFFFF',
        black: '#000000',
        gray: '#BFBFBF',

        success: '#4E41F0',
        info: '#F7931B',
        warning: '#E44C4E'
    }
}